import React, {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import styled from "styled-components";
import { useLanguage } from "../i18n";

const Button = styled.button`
    display: block;
    font-size: 0.9rem;
    margin: 0 auto;
    padding: 0 10px;
    border-radius: 0.6rem;

    :hover {
        cursor: pointer;
    }
`;

const HomeButton = () => {
  const navigate = useNavigate();
  const { t, localePath } = useLanguage();
  const handleOnClick = useCallback(() => navigate(localePath('/'), {replace: true}), [navigate, localePath]);

  return (
    <Button type="button" onClick={handleOnClick}>
      {t('homeButton')}
    </Button>
  );
}

export default HomeButton;
